import useLocallyStoredState from "./useLocallyStoredState";

const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");

export default () =>
  useLocallyStoredState("color-mode", prefersDark ? "dark" : "light");
